// TODO: remove
export const selectSelectedOffer = (state) => {
  if (Object.keys(state.review.calc).length === 0) {
    return {};
  }

  // TODO: GET RID OF THIS -- we don't care about offer keys anymore
  const key = Object.keys(state.review.calc.selectedOffers)[0];
  const {availableOffers} = state.review.calc;
  if (!key || !availableOffers) return {};
  const offer = availableOffers.find((o) => o.offerKey === key);
  if (!offer) {
    return {};
  }
  return offer;
};
export const selectSender = ({review}) => review.eventHostName;
export const selectDeliverCardNow = ({review}) => review.deliverCardNow;

export const selectDeliveryCardDateTime = ({review}) => review.deliveryCardDateTime;

export const selectDeliveryCardTimezone = ({review}) => ({
  known_timezone_abbr: review.known_timezone_abbr,
  known_timezone_name: review.known_timezone_name,
});

export const selectVirtualQuantity = (state) => {
  const {virtualQuantity} = selectSelectedOffer(state);
  return virtualQuantity;
};

export const selectDisplayPrice = (state) => {
  const {displayPrice} = selectSelectedOffer(state);
  return displayPrice;
};
export const selectPromoCode = (state) => {
  const {promocode} = state.review.calc;
  return promocode;
};
export const selectPromoType = (state) => {
  const {promoType} = state.review.calc;
  return promoType;
};
export const selectPurchaseChargeId = (state) => {
  const {charge_id} = state.review.purchase_response;
  return charge_id;
};

export const selectTransactionId = (state) => {
  const {transaction} = state.review.purchase_response;
  return transaction;
};

// GTM/dataLayer reporting requires '1.99' not '$1.99'
export const selectEcommerceDisplayPrice = (state) => {
  const selectedOffer = selectSelectedOffer(state);
  if (selectedOffer) {
    return selectedOffer.displayPrice?.substring(1);
  }
  return state.review?.calc?.amountToBeCharged?.substring(1) || '0.00';
};

// GTM/dataLayer reporting individual product data for checkout
export const selectEcommerceProduct = (state) => ({
  quantity: selectVirtualQuantity(state),
  price: selectEcommerceDisplayPrice(state),
  brand: 'Evite',
});

const actionFieldDefaults = {
  affiliation: 'Fabric GreetingCard',
  tax: 0.0,
  shipping: 0.0,
  promoType: '',
  promocode: '',
};

// GTM/dataLayer reporting action field data for checkout
export const selectActionField = (state) => {
  const revenue = selectDisplayPrice(state);
  const id = selectPurchaseChargeId(state);
  const promocode = selectPromoCode(state);
  const promoType = selectPromoType(state);

  return {...actionFieldDefaults, revenue, id, promoType, promocode};
};

// GTM/dataLayer Ecommerce reporting field data for checkout
export const selectEcommerceObject = (state) => {
  const actionField = state.review.purchase_response ? selectActionField(state) : null;
  const products = [selectEcommerceProduct(state)];
  const purchasePrice = selectEcommerceDisplayPrice(state);
  const transaction_id = state.review.purchase_response ? selectTransactionId(state) : null;
  const {offerId: offer_id} = selectSelectedOffer(state);

  return {
    ecommerce: {actionField, products},
    offer_id,
    purchasePrice,
    transaction_id,
  };
};

export const selectShareableLinkPremiumUpsell = (state) =>
  state?.review?.shareableLinkPremiumUpsell;

export const selectReview = (state) => state.review;
